import { fetchUrl } from './settings';
import { ActionType } from '../action-types';
import axios from 'axios';

const sanitizeForFilename = (name: string): string =>
	name.replace(/[^a-z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/gi, '_');

//download measurements for node (on node card)
export const download = (formData, nodeName, systemName, nodeID) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.CLOSE_NO_MEASUREMENTS_WARNING, payload: nodeID });
	dispatch({ type: ActionType.EXPORT_START, payload: nodeID });
	fetch(`${fetchUrl}/export`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			if (response.status === 404) {
				dispatch({ type: ActionType.SHOW_NO_MEASUREMENTS_WARNING, payload: nodeID });
				throw new Error('No measurements in this range');
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();
			systemName = sanitizeForFilename(systemName);
			nodeName = sanitizeForFilename(nodeName);

			a.href = url;
			a.download = `export-${systemName}-${nodeName}-${res}.xlsx`;
			a.download = a.download.toLocaleLowerCase();
			document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
			a.click();
			a.remove(); //afterwards we remove the element again
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: nodeID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: nodeID });
		});
};

export const showNoMeasurementsWarning = () => (dispatch) => {
	return dispatch({ type: ActionType.SHOW_NO_MEASUREMENTS_WARNING });
};

export const closeNoMeasurementsWarning = (nodeID) => (dispatch) => {
	return dispatch({ type: ActionType.CLOSE_NO_MEASUREMENTS_WARNING, payload: nodeID });
};


export const exportUsers = (sysID, sysName, allSystems) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/export-users`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({sysID: sysID, all: allSystems}),
	})
		.then((response) => {
			if (!response.ok) {
				dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
				throw new Error('No users in this system');
			}
			return response.blob();
		})
		.then((blob) => {
			console.log('blob', blob);
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();
			sysName = allSystems ? 'All' : sanitizeForFilename(sysName);

			a.href = url;
			a.download = `export-users-${sysName}-${res}.xlsx`;
			a.download = a.download.toLocaleLowerCase();
			document.body.appendChild(a);
			a.click();
			a.remove(); 
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};



export const exportAccounts = (sysID, sysName, allSystems) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/export-accounts`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({sysID: sysID, all: allSystems}),
	})
		.then((response) => {
			if (!response.ok) {
				dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
				throw new Error('No users in this system');
			}
			return response.blob();
		})
		.then((blob) => {
			console.log('blob', blob);
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();
			sysName = allSystems ? 'All' : sanitizeForFilename(sysName);

			a.href = url;
			a.download = `export-accounts-${sysName}-${res}.xlsx`;
			a.download = a.download.toLocaleLowerCase();
			document.body.appendChild(a);
			a.click();
			a.remove(); 
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};

export const exportNodes = (sysID, sysName, allSystems) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/export-nodes`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({sysID: sysID, all: allSystems}),
	})
		.then((response) => {
			if (!response.ok) {
				dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
				throw new Error('No nodes in this system');
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();
			sysName = allSystems ? 'All' : sanitizeForFilename(sysName);

			a.href = url;
			a.download = `export-nodes-${sysName}-${res}.xlsx`;
			a.download = a.download.toLocaleLowerCase();
			document.body.appendChild(a);
			a.click();
			a.remove(); 
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};

export const exportMeasurements = (sysID, sysName, nodeIds, dateStart, dateEnd) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/export-measurements`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({sysID: sysID, nodeIds: nodeIds, dateStart: dateStart, dateEnd: dateEnd}),
	})
		.then((response) => {
			if (!response.ok) {
				if (response.status == 404) {
					dispatch({ type: ActionType.EXPORT_FAILED_NO_DATA, payload: sysID });
					dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
					return;
				} else {
					dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
					throw new Error('Failed to export logs');
				}
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();
			sysName = sanitizeForFilename(sysName);

			a.href = url;
			a.download = `export-measurements-${sysName}-${dateStart.toISOString()}-${dateEnd.toISOString()}-${res}.csv`;
			a.download = a.download.toLocaleLowerCase();
			document.body.appendChild(a);
			a.click();
			a.remove(); 
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};

export const exportSystems = (sysID, sysName, allSystems) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/export-systems`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({sysID: sysID, all: allSystems}),
	})
		.then((response) => {
			if (!response.ok) {
				dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
				throw new Error('No systems');
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();
			sysName = allSystems ? 'All' : sanitizeForFilename(sysName);

			a.href = url;
			a.download = `export-systems-${sysName}-${res}.xlsx`;
			a.download = a.download.toLocaleLowerCase();
			document.body.appendChild(a);
			a.click();
			a.remove(); 
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};

// PDF report of the picked nodes of a system (deflection report, signal quality report)
const exportPdfReport = (path, filenamePrefix, sysID, nodesIDs, sysName, dateStart, dateEnd, comments, includeVoltage) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}${path}`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({systemID: sysID, nodesIDs: nodesIDs, fromDate: dateStart, toDate: dateEnd, comment: comments, includeVoltage: includeVoltage}),
	})
		.then((response) => {
			if (!response.ok) {
				dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
				throw new Error('No systems');
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');

			function formatDate(date) {
				const pad = (n) => n.toString().padStart(2, '0');
				return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
			}

			function formatDateTime(date) {
				const pad = (n) => n.toString().padStart(2, '0');
				return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}-${pad(date.getHours())}-${pad(date.getMinutes())}`;
			}

			let now = new Date();
			let sysNameSafe = sanitizeForFilename(sysName);

			let filename = `${filenamePrefix}-${sysNameSafe}-from-${formatDate(dateStart)}-to-${formatDate(dateEnd)}-on-${formatDateTime(now)}.pdf`;

			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();
			a.remove();
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};

export const exportReport = (sysID, nodesIDs, sysName, dateStart, dateEnd, comments, includeVoltage) =>
	exportPdfReport('/get-report', 'report', sysID, nodesIDs, sysName, dateStart, dateEnd, comments, includeVoltage);

export const exportSignalQualityReport = (sysID, nodesIDs, sysName, dateStart, dateEnd, comments) =>
	exportPdfReport('/get-signal-quality-report', 'signal-quality-report', sysID, nodesIDs, sysName, dateStart, dateEnd, comments, false);


export const exportInstallationProtocol = (sysID, sysName) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/installation-protocol`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		// odbiorca is the buyer assigned to the system
		body: JSON.stringify({ systemId: sysID }),
	})
		.then((response) => {
			if (!response.ok) {
				dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
				throw new Error('Failed to export installation protocol');
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');

			let now = new Date();
			const pad = (n) => n.toString().padStart(2, '0');
			let timestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
			let sysNameSafe = sanitizeForFilename(sysName);

			a.href = url;
			a.download = `installation-protocol-${sysNameSafe}-${timestamp}.pdf`;
			document.body.appendChild(a);
			a.click();
			a.remove();
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};

export const exportGnuplotCharts = (sysID, nodesIDs, nodeIDSAdvanced, sysName, dateStart, dateEnd, format, chartType) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/get-gnuplot-charts`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			systemID: sysID, 
			nodesIDsStandard: nodesIDs, 
			nodesIDsAdvanced: nodeIDSAdvanced, 
			fromDate: dateStart, 
			toDate: dateEnd, 
			format: format, 
			chartType: chartType
		}),
	})
		.then((response) => {
			if (!response.ok) {
				dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
				throw new Error('No systems');
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');

			function formatDateCompact(date) {
				const pad = (n) => n.toString().padStart(2, '0');
				return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
			}

			let sysNameSafe = sanitizeForFilename(sysName);

			let filename = `${format.toUpperCase()}-${sysNameSafe}-${formatDateCompact(dateStart)}-${formatDateCompact(dateEnd)}.tar.gz`;

			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();
			a.remove();
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};

export const exportLogs = (sysID, nodesIDs, sysName, dateStart, dateEnd, message) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({ type: ActionType.EXPORT_START, payload: sysID });
	fetch(`${fetchUrl}/export-logs`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({sysID: sysID, nodesIDs: nodesIDs, dateStart: dateStart, dateEnd: dateEnd, message: message}),
	})
		.then((response) => {
			if (!response.ok) {
				if (response.status == 404) {
					dispatch({ type: ActionType.EXPORT_FAILED_NO_DATA, payload: sysID });
					dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
					return;
				} else {
					dispatch({ type: ActionType.EXPORT_FAILED, payload: sysID });
					throw new Error('Failed to export logs');
				}
			}
			return response.blob();
		})
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();
			sysName = sanitizeForFilename(sysName);

			a.href = url;
			a.download = `export-logs-${sysName}-${dateStart.toISOString()}-${dateEnd.toISOString()}-${res}.csv`;
			a.download = a.download.toLocaleLowerCase();
			document.body.appendChild(a);
			a.click();
			a.remove(); 
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: sysID });
		});
};